










































import { Component, Vue, Prop } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { UserModel } from "@/model/user/userModel";
import { version } from "../../../package.json";

const StoreAuthentication = namespace("Authentication");
@Component
export default class Footer extends Vue {
  @Prop({ default: false }) isAuthorized!: boolean;

  @StoreAuthentication.Getter
  private getUserInfo!: UserModel | null;
  private version = version;

  private widthScreen = 0;

  mounted() {
    this.widthScreen = window.innerWidth;
    window.addEventListener("resize", () => {
      this.widthScreen = window.innerWidth;
    });
  }

  public RedirectToPEAK() {
    window.open("https://peakaccount.com/main.html");
  }
  public RedirectToRegister() {
    window.open(`${process.env.VUE_APP_PeakAccount}register/select_register`);
  }
}
